import Count         from "../../../../domain/fundamentals/count/Count";
import ReservationId from "../../../../domain/reservation/ReservationId";
import { ApiClient } from "../../../configure/ApiClientConfig";

export const apiGetReservationCancelRequestCount = async (): Promise<Count> => {
  try {
    const response = await ApiClient.get("/reservation/cancel/request/count");
    return new Count(response.data.count);
  } catch (e) {
    return new Count();
  }
}

export const apiPutAcceptReservationCancelRequest = async (reservationId: ReservationId): Promise<void> => ApiClient.put("/reservation/cancel/request/accept", {
  reservation_id: reservationId.value,
});
